import { customElement, property } from 'lit/decorators.js';
import { GzDonutChartWidgetWebComponent } from '../../../../ui/gzDonutChartWidget';
import { PropertyValues } from 'lit';
import { translateFn } from '../../../../utils/translator.helper';
import { NavigationHelper } from '@nirvana/shared/navigation';
import { ColumnKeys as VulnerabilitiesAppColumnKeys } from '../../../vulnerabilitiesApp/types';
import { WEB_COMPONENT_GZ_RM_VULNERABILITIES_BREAKDOWN_WIDGET } from '../../../../webcomponents.constants';
import { DonutChartWidgetPayload, DonutChartWidgetSliceConfig } from '@nirvana/shared/dtos/types/widgets/common';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';
import { State } from '../../../common/constants';

/**
 * @summary Type here the description of this component
 * @tag gz-rm-vulnerabilities-breakdown-widget
 */
@customElement(WEB_COMPONENT_GZ_RM_VULNERABILITIES_BREAKDOWN_WIDGET)
export class GzRmVulnerabilitiesBreakdownWidgetWebComponent extends GzDonutChartWidgetWebComponent {
  @property({ type: Object, attribute: true })
  payload: DonutChartWidgetPayload & { companyId?: string };

  private hoverColor: string;

  constructor() {
    super();
  }

  firstUpdated() {
    super.firstUpdated();
    this.hoverColor = getComputedStyle(document.body).getPropertyValue('--blue-layout-400-primary');
    this.style.setProperty('--top-padding', '0');
  }

  async updated(changedProperties: PropertyValues) {
    await super.updated(changedProperties);
    this.style.setProperty('--hover-color', this.hoverColor);
  }

  willUpdate(properties: PropertyValues) {
    super.willUpdate(properties);

    if (properties.has('payload')) {
      if (this.payload.donutChart?.config) {
        this.payload.donutChart.config.label = translateFn('vulnerabilities');
        this.payload.donutChart.config.slices = this.payload.donutChart.config.slices.map(slice => ({
          ...slice,
          label: BaseWebComponentTranslator.getInstance().getRiskManagementApplicationType(parseInt(slice.id, 10)),
        }));
      }
    }
  }

  public handleTitleClick(): void {
    this.viewAll();
  }

  protected viewAll(): void {
    NavigationHelper.navigateToRiskManagement({
      company: { id: this.payload.companyId ?? '' },
      filters: [
        {
          [VulnerabilitiesAppColumnKeys.STATE]: { in: [State.ACTIVE] },
        },
        {
          [VulnerabilitiesAppColumnKeys.RISK_SCORE]: { range: { min: 1, max: 100 } },
        },
      ],
      section: 'vulnerabilities',
      newTab: true,
    });
  }

  protected handleChartLegendItemClick(sliceConfig: DonutChartWidgetSliceConfig) {
    NavigationHelper.navigateToRiskManagement({
      company: { id: this.payload.companyId ?? '' },
      section: 'vulnerabilities',
      filters: [
        {
          [VulnerabilitiesAppColumnKeys.APPLICATION_TYPE]: { in: [parseInt(sliceConfig.id, 10)] },
        },
        {
          [VulnerabilitiesAppColumnKeys.STATE]: { in: [State.ACTIVE] },
        },
        {
          [VulnerabilitiesAppColumnKeys.RISK_SCORE]: { range: { min: 1, max: 100 } },
        },
      ],
      newTab: true,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-rm-vulnerabilities-breakdown-widget': GzRmVulnerabilitiesBreakdownWidgetWebComponent;
  }
}
